export const PROD_PRINCIP = 'princip';
export const PROD_PRODLINE = 'prodLine';
export const PROD_SELECTED_PRINCIP = 'selectedPrincip';
export const PROD_SELECTED_PRODLINE = 'selectedProdLine';
export const PROD_PRODFAMILY = 'prodFamily';
export const PROD_N_WAYS_VALVE = 'nWaysValve';
export const PROD_GREEN_LEVEL = "greenLevel"